<template>
  <div class="cost-analysis-table">
    <!-- <img alt="Cost Analysis" src="../assets/sp2lnob/Cost_Analysis.png" /> -->
    <data-table
      :chart-options="tableOptions"
      :data="dataObjectStr">
      </data-table>
    <div class="note ps-2 pt-2">Breakdown of Costs by Benefit Type</div>
  </div>
</template>

<script>
import DataTable from '@wc/data-table/data-table.vue';

export default {
  name: 'CostAnalysisTable',
  components: { DataTable },
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      dataObj: {
        columns: [
          // {
          //   name: 'Benefit Type',
          //   type: 'string'
          // },
          // {
          //   name: 'Transfer Amount',
          //   type: 'string'
          // },
          // {
          //   name: 'Eligible Recipients',
          //   type: 'string'
          // },
          // {
          //   name: 'Program Cost',
          //   type: 'string'
          // },
          // {
          //   name: 'Admin Rate',
          //   type: 'string'
          // },
          // {
          //   name: 'Admin Cost',
          //   type: 'string'
          // },
          // {
          //   name: 'Total Cost',
          //   type: 'string'
          // }
        ],
        data: [
          // ['Child Benefits', '7,255.32', '152,420', '188,039,808', '5%', '9,401,990', '197,441,798'],
          // ['Elderly Benefits', '29,021.28', '21,697', '153,049,077', '5%', '7,652,454', '160,701,531'],
          // ['Disability Benefits', '25,393.62', '36,610', '198,921,824', '5%', '9,946,091', '208,867,916'],
          // ['Total', 'NA', '210,727', '540,010,709', '5%', '27,000,535', '567,011,245']
        ]
      },
      dataObjectStr: '{"data":[],"colums":[]}',
      tableOptions: {
        allowSearch: false,
        paging: false,
        csvDownload: true
      }
    };
  },
  mounted () {
    this.getTableData();
  },
  watch: {
    data: {
      handler: function (data) {
        // console.log('cost analysis');
        // console.log(data);
        const newTbData = {
          data: [],
          columns: []
        };
        if (data.length > 0) {
          for (const d of data) {
            delete d._row;
            newTbData.data.push(Object.values(d));
          }
          for (const key of Object.keys(data[0])) {
            newTbData.columns.push({ name: key, type: 'string' });
          }
          // console.log(JSON.stringify(newTbData));
          this.dataObjectStr = JSON.stringify(newTbData);
        }
      }
    }
  },
  methods: {
    getTableData: function () {
      this.dataObjectStr = JSON.stringify(this.dataObj);
    }
  }
};
</script>

<style lang="css">
.cost-analysis-table img {
  width: 100%;
}
.cost-analysis-table div.dt-buttons {
  float: right;
  font-family: Inter;
  font-size: 14px;
}
.cost-analysis-table table.dataTable td, .cost-analysis-table table.dataTable th {
    font-size: 16px;
    font-family: Roboto;
    line-height: normal;
}
.cost-analysis-table .note {
  color: rgba(105, 105, 105, 0.75);
  font-family: Roboto;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
